import _util from '../../utils/';


const WorkReportExemptService = {
    select(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportExempt/Get',
            params: data,
            success: resolve,
            error: reject
        })
    },

    delete(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportExempt/BatchDelete',
            method: "delete",
            data: data,
            success: resolve,
            error: reject
        })
    },
    update(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportExempt/Put',
            method: "put",
            data: data,
            success: resolve,
            error: reject
        })
    },

    create(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportExempt/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        })
    },
};


export default WorkReportExemptService;


// WEBPACK FOOTER //
// ./src/services/WorkReport/work-report-exempt-service.js